import React, { useState } from 'react';
import { ShieldCheckIcon, XMarkIcon } from '../../icons';

const CertifyModal = ({
  open,
  onClose,
  onConfirm,
  transcriptionTitle,
  certifying,
  error,
}) => {
  const [correctionSummary, setCorrectionSummary] = useState('');

  if (!open) return null;

  const handleConfirm = () => {
    onConfirm(correctionSummary.trim());
  };

  const handleClose = () => {
    setCorrectionSummary('');
    onClose();
  };

  return (
    <div className="md-modal-overlay">
      <div className="md-modal" role="dialog" aria-modal="true" aria-labelledby="certify-modal-title">
        <div className="md-modal-header">
          <div className="flex items-center gap-2">
            <div className="md-icon-well bg-matdash-primary-subtle text-matdash-primary">
              <ShieldCheckIcon className="h-5 w-5" />
            </div>
            <h2 id="certify-modal-title" className="text-lg font-semibold text-matdash-dark mb-0">
              Certify transcript
            </h2>
          </div>
          <button type="button" onClick={handleClose} className="text-matdash-muted hover:text-matdash-dark">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="md-modal-body space-y-4">
          <p className="text-sm text-matdash-muted">
            You are certifying{' '}
            <span className="font-medium text-matdash-dark">
              {transcriptionTitle || 'this transcript'}
            </span>{' '}
            as the official court record. After certification, editing will be locked and your name and role will be recorded.
          </p>

          <div>
            <label htmlFor="correction-summary" className="block text-sm font-medium text-matdash-dark mb-1">
              Correction summary (optional)
            </label>
            <textarea
              id="correction-summary"
              rows={3}
              value={correctionSummary}
              onChange={(e) => setCorrectionSummary(e.target.value)}
              placeholder="Brief note on corrections made during review…"
              className="md-form-control w-full"
            />
          </div>

          {error && (
            <p className="md-alert md-alert-danger">{error}</p>
          )}
        </div>

        <div className="md-modal-footer">
          <button
            type="button"
            onClick={handleClose}
            disabled={certifying}
            className="flex-1 md-btn md-btn-outline"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={certifying}
            className="flex-1 md-btn md-btn-primary disabled:opacity-50"
          >
            {certifying ? 'Certifying…' : 'Certify as official record'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CertifyModal;
